// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3OmHo","question":"Question_question__1307f","description":"Question_description__vx80U"};